var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"type":"button","primary":"","outline":"","small":""},on:{"click":_vm.onRevoke}},[_vm._v(" Revoke ")])
}
var staticRenderFns = []

export { render, staticRenderFns }